import {createStyles, useMantineTheme} from '@mantine/core';
import React from 'react';
import {Background} from 'reactflow';

/**
 * Number of pixels between dots in the background grid. As the zoom changes, the gap will be scaled
 * relative to the zoom level to help the user contextualize the zoom level.
 */
const GAP = 24;
/**
 * Reactflow seems to use the pixel size at 200% zoom to determine what the circle size is scaled to
 * This will ensure that at 100% zoom the dot size is 2px, and at 200% zoom the dot size is 4px.
 */
const DOT_SIZE_AT_200_PERCENT = 4;

interface DefaultBackgroundProps {}

/**
 * Customized ReactFlow background with standardized styling, to help users visualize the zoom level.
 * This component is designed to be used within a ReactFlow component.
 *
 * Customized version of <Background /> from reactflow, can be used in the same way.
 *
 * Ex:
 * <ReactFlow
 *   nodes={nodes}
 *   edges={edges}
 * />
 *   <DefaultBackground />
 * </ReactFlow>
 */
const useStyles = createStyles((theme) => ({
  background: {
    backgroundColor: theme.colors.gray[0],
  },
}));

export default function DefaultBackground(props: DefaultBackgroundProps): JSX.Element {
  const {classes} = useStyles();
  const theme = useMantineTheme();
  return (
    <Background
      gap={GAP}
      size={DOT_SIZE_AT_200_PERCENT}
      color={theme.colors.gray[2]}
      className={classes.background}
    />
  );
}
